/**
 * Web implementation of the `Transport` interface — wraps the global `fetch`.
 * RN provides its own `fetch` polyfill, so an RN equivalent of this file
 * could be a one-line re-export.
 */

import type {
  RequestOptions,
  Transport,
  TransportResponse,
} from "@/core/api/transport";

export const fetchTransport: Transport = {
  async request(
    url: string,
    options?: RequestOptions,
  ): Promise<TransportResponse> {
    const init: RequestInit = {
      method: options?.method ?? "GET",
      headers: options?.headers,
      body: options?.body ?? null,
    };
    if (options?.signal) {
      init.signal = options.signal;
    }
    const response = await fetch(url, init);
    return {
      status: response.status,
      ok: response.ok,
      headers: response.headers,
      text: () => response.text(),
    };
  },
};
